import { get } from "api";
import {SearchResponse, hotResponse } from "types/search";

export const postSearch = (str: string) =>
    get<{ str: string }, SearchResponse>("/api/all_user/search", { str })

export const getSearchHot = () =>
    get<{}, hotResponse>("/api/all_user/default_search")

